import { ReactElement } from 'react';
import { Header } from '@designSystem/typings';
import { ExactDateFilter } from '@root/src/app/designSystem/dateFilter';
import SearchInput from '@root/src/app/designSystem/searchInput';
import { NullableString, SelectOption } from '@app/common/types';
import { dayjs } from '@app/utils';
import {
  OnChangeSearchTextType,
  OnSetFilterDateType,
} from '../ordersTable/types';
import { MobileFilterContainer, MobileHeaderContainer } from './styles';
import Lang from '@lang/en';
import { CloseMark } from '@root/src/assets/images';
import DropDown from '@designSystem/dropDown';

type FilterBarComponentI = {
  selectedStartDate: NullableString;
  searchText?: string;
  onChangeSearchText: OnChangeSearchTextType;
  onSetFilterDate: OnSetFilterDateType;
  handleClose: () => void;
  handleChangeTestFilter: (value: string) => void;
  typeFilterOptions: Array<SelectOption>;
  currentTestFilterOption: SelectOption;
};

export const FiltersMobile = ({
  selectedStartDate,
  searchText,
  onChangeSearchText,
  onSetFilterDate,
  handleClose,
  typeFilterOptions,
  handleChangeTestFilter,
  currentTestFilterOption,
}: FilterBarComponentI): ReactElement => {
  return (
    <>
      <MobileHeaderContainer>
        <Header>{Lang.healthCheckSearchAndFilters}</Header>
        <CloseMark
          aria-label="close"
          data-testid="healthcheck-filters-close-button"
          onClick={handleClose}
        />
      </MobileHeaderContainer>
      <MobileFilterContainer>
        <SearchInput
          defaultValue={searchText}
          handleSearchChange={onChangeSearchText}
        />
        {/* <DropDown
          onChange={(option) => handleChangeTestFilter(option?.value as string)}
          options={typeFilterOptions}
          beforeText={Lang.healthCheckTestTypeDropdownBeforeText}
          value={currentTestFilterOption}
        /> */}
        <ExactDateFilter
          data-testid="healthcheck-dashboard-date-filter"
          value={selectedStartDate}
          onDateChange={(value): void => {
            if (!value) {
              onSetFilterDate(null);
              return;
            }
            const date = dayjs(value);
            const formattedDate = date.format('YYYY-MM-DD');
            onSetFilterDate(formattedDate);
          }}
        />
      </MobileFilterContainer>
    </>
  );
};

export default FiltersMobile;
